<template>
  <el-card class="box-card" :style="{ height: height, width: width }">
    <!-- header -->
    <div slot="header" class="clearfix">
      <span>{{ cardTitle }}</span>
    </div>
    <!-- 滚动列表容器 -->
    <div class="list-container" :style="{ height: height ? `calc(${height} - 40px)` : '300px' }">
      <!-- 遍历列表，用 el-tooltip 包裹文本 -->
      <div v-for="(item, index) in listData" :key="index" class="text item">
        <!-- el-tooltip：悬浮显示完整内容 -->
        <el-tooltip
          placement="top"
          effect="dark"
          :content="item"
          :disabled="!isTextOverflow($refs[`item-${index}`])"
        >
          <!-- 文本容器：添加 ref 用于判断是否溢出 -->
          <span :ref="`item-${index}`" class="overflow-text">
            {{ item }}
          </span>
        </el-tooltip>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'CustomeListCard',
  props: {
    cardTitle: {
      type: [String],
      default: '列表标题'
    },
    height: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: [String, Number],
      default: ''
    },
    listData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    /**
     * 判断文本是否溢出容器
     * @param {HTMLElement} el - 文本元素DOM节点
     * @returns {boolean} - 是否溢出
     */
    isTextOverflow(el) {
      if (!el) return false;
      // 关键判断：scrollWidth（文本实际宽度）> clientWidth（容器可视宽度）
      return el.scrollWidth > el.clientWidth;
    }
  }
}
</script>

<style scoped>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
  text-align: center;
  /* 给文本容器预留足够宽度（避免父容器挤压） */
  width: 100%;
}

/* 文本溢出样式：核心 */
.overflow-text {
  display: inline-block;  /* 必须：让 scrollWidth/clientWidth 生效 */
  width: 100%;            /* 宽度继承父容器，确保超出时触发溢出 */
  white-space: nowrap;    /* 禁止换行 */
  overflow: hidden;       /* 隐藏溢出部分 */
  text-overflow: ellipsis;/* 溢出显示... */
  cursor: pointer;        /* 鼠标悬浮变指针，提示可点击/查看 */
}

.clearfix {
  text-align: center;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

/* 列表滚动容器 */
.list-container {
  padding: 0 16px 16px;
  height: calc(100% - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* 美化滚动条 */
.list-container::-webkit-scrollbar {
  width: 6px;
}
.list-container::-webkit-scrollbar-thumb {
  background-color: #e5e7eb;
  border-radius: 3px;
}
.list-container::-webkit-scrollbar-thumb:hover {
  background-color: #d1d5db;
}

/* 修复 el-tooltip 样式冲突（可选） */
::v-deep .el-tooltip__popper {
  max-width: 300px; /* 限制提示框最大宽度，避免过宽 */
  word-wrap: break-word; /* 长文本自动换行 */
}
</style>